LoginPage.vue
<script setup lang="ts">
import AuthLayout from '../../layouts/AuthLayout.vue';
import { Link, useForm, usePage } from '@inertiajs/vue3';
import { route } from 'ziggy-js';
import { AuthPageProps } from '../../index';

const form = useForm({
  email: '',
});
const page = usePage<AuthPageProps>();

function submit() {
  form.post(route('password.email'));
}
</script>

<template>
  <AuthLayout :title="$t('auth.login')">
    <VForm @submit.prevent="submit">
      <VCardItem>
        <VAlert v-if="page.props.status" type="success">{{ page.props.status }}</VAlert>
        <VCardText class="text-center">{{ $t('auth.forgotPassword.explanation') }}</VCardText>
        <VTextField
          v-model="form.email"
          :error-messages="form.errors.email"
          :label="$t('auth.field.email')"
          autofocus
          hide-details="auto"
          type="email"
          required
        />
      </VCardItem>
      <VCardActions class="text-center">
        <VBtn block type="submit">{{ $t('auth.requestPasswordResetLink') }}</VBtn>
      </VCardActions>
      <VCardItem class="text-center">
        <Link :href="route('login')">{{ $t('auth.backToLogin') }}</Link>
      </VCardItem>
    </VForm>
  </AuthLayout>
</template>
